// src/public/formatPower.js

export const formatPower = (power, type) => {
  if (power < 1000) {
    return {
      value: (power / 1000).toFixed(3),
      unit: (type === "Add") ? "kWh" : "kW"
    };
  } else if (power < 1000000) {
    return {
      value: (power / 1000).toFixed(2),
      unit: (type === "Add") ? "kWh" : "kW"
    };
  } else if (power >= 1000000 && power < 1000000000) {
    return {
      value: (power / 1000000).toFixed(3),
      unit: (type === "Add") ? "MWh" : "MW" // Add 타입이면 MWh
    };
  } else {
    return {
      value: (power / 1000000000).toFixed(3),
      unit: (type === "Add") ? "GWh" : "GW" // Add 타입이면 GWh
    };
  }
};



  // CO₂ 절감량 계산 및 표시 형식
  export const formatCO2Reduction = (power) => {
    const co2Reduction = (power / 1000) * 0.424;
    if (co2Reduction < 1000) {
      return {
        value: co2Reduction.toFixed(1),
        unit: 'kgCO₂'
      };
    } else if (co2Reduction >= 1000 && co2Reduction < 1000000) {
      return {
        value: (co2Reduction / 1000).toFixed(1),
        unit: 'tCO₂'
      };
    } else {
      return {
        value: (co2Reduction / 1000000).toFixed(1),
        unit: 'ktCO₂'
      };
    }
  };